import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ClientNotificationInterface } from '../data';
import { ClientProvider } from '../providers/client.provider';
import { Transaction } from '../transaction/transaction';
import { UseCase } from './common/use.case';

@Injectable()
export class GetValidateClientNotificationsUseCase implements UseCase<Observable<Transaction<ClientNotificationInterface[]>>> {
    constructor(private clientProvider: ClientProvider) {}

    bind(): Observable<Transaction<ClientNotificationInterface[]>> {
        return this.clientProvider.validateNotifications();
    }
}
